import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TSwedBankApi } from './types';

export const swedBank: TSwedBankApi = {
	getSwedBankIntegration: payload =>
		http.post(endpoint.swedBank.GET_SWED_BANK_DOCKS, payload).then(response => response.data),
	uploadStatementFile: payload =>
		http.post(endpoint.swedBank.UPLOAD_STATEMENT, payload).then(response => response.data),
	searchInvoices: payload =>
		http.post(endpoint.swedBank.SEARCH_INVOICE, payload).then(response => response.data),
	markAsProcessed: payload =>
		http.post(endpoint.swedBank.MARK_AS_PROCESSED, payload).then(response => response.data),
	attachVatReimbursement: payload =>
		http
			.post(endpoint.swedBank.ATTACH_VAT_REIMBURSEMENT, payload.body)
			.then(response => response.data),
};
